// extracted by mini-css-extract-plugin
export default {"nav":"navbar_nav__0eEOB"};